export enum EmailEntityType {
  FLOWCODE = 'Flowcode',
  TEMPLATE = 'Template'
}
